<script setup lang="ts">
import { mdiCircle } from "@mdi/js";
import {
	DropdownMenuItemIndicator,
	DropdownMenuRadioItem,
	useForwardPropsEmits,
	type DropdownMenuRadioItemEmits,
	type DropdownMenuRadioItemProps,
} from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";
import Icon from "../icon/Icon.vue";

interface Props extends Omit<DropdownMenuRadioItemProps, "as" | "asChild">, ClassProps {}

const props = defineProps<Props>();
const emit = defineEmits<DropdownMenuRadioItemEmits>();

const delegatedProps = useDelegatedProps(props);

const forwarded = useForwardPropsEmits(delegatedProps, emit);
</script>

<template>
	<DropdownMenuRadioItem as="li" v-bind="forwarded">
		<div :class="cn('pl-8 pr-2', props.class)">
			<span class="flex-center absolute left-2 size-3.5">
				<DropdownMenuItemIndicator>
					<Icon class="size-2" :d="mdiCircle" />
				</DropdownMenuItemIndicator>
			</span>
			<slot />
		</div>
	</DropdownMenuRadioItem>
</template>
